export { mileage };
// @ts-check

/** @type {import('./types/reports.types').ReportsContent} */
const mileage = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'no', header: 'No.' },
          { field: 'assetName', header: 'Asset' },
          { field: 'minMileage', header: 'Start Mileage (km)' },
          { field: 'maxMileage', header: 'End Mileage (km)' },
          { field: 'travelledMileage', header: 'Distance Travelled (km)' },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'View Daily Breakdown',
                  icon: 'icon-calendar',
                  iconPack: 'feather',
                  click: { component: 'ModalTable', data: onReady },
                },
              ],
            },
          },
        ],
      },
      pdf: {
        title: 'Mileage - Summary',
        colsWidth: [20, 110, 110, 110, 110],
      },
    },
  ];
};

const onReady = {
  onReady: function (self) {
    let args = self.data.rowData;
    let modal = JSON.parse(JSON.stringify(modalTableApi));

    return new Promise((resolve) => {
      if (args.travelledMileage == 0) {
        self.$vs.notify({
          title: 'Error',
          text: 'No data available',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        resolve(false);
      } else if (args.travelledMileage != 0) {
        self.isLoading = true;
        self.$http
          .post('reports-utils/getIndividualMileageBreakdown', {
            timeRange: self.timeRange,
            uid: self.uid,
            unitId: args.unitId,
            assetId: args.assetId,
            assetName: args.assetName,
          })
          .then(function (response) {
            if (response.status == 200 && response.data.success) {
              let breakdownData = [];
              breakdownData.push({
                assetId: args.assetId,
                assetName: args.assetName,
                arr: response.data.singleBreakdownArray,
              });
              breakdownData[0].arr.forEach((e) => {
                modal.reportData.push(e);
              });
              modal.title = `Day Breakdown - ${args.assetName}`;
              modal.pdf.title = modal.title;
              self.onReadyData = modal;

              // self.forceRender += 1;
              // self.activeTab = self.breakdownData.length;
              // self.isLoading = false;
              resolve(true);
            } else {
              self.isLoading = false;
              if (response.data.error) {
                self.$vs.notify({
                  title: 'Error',
                  text: 'Try again later.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                });
                resolve(false);
              } else {
                self.$vs.notify({
                  title: 'Error',
                  text: 'Try again later.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                });
                resolve(false);
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            // self.isLoading = false;

            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          });
      }
    });
  },
};

const modalTableApi = {
  title: null,
  reportData: [],
  table: {
    content: [
      { field: 'no', header: 'No.' },
      { field: 'assetName', header: 'Asset' },
      { field: 'date', header: 'Date' },
      { field: 'startMileage', header: 'Start Mileage (km)' },
      { field: 'endMileage', header: 'End Mileage (km)' },
      { field: 'travelledMileage', header: 'Distance Travelled (km)' },
    ],
  },
  pdf: {
    title: null,
    colsWidth: [20, 110, 110, 110, 110, 110],
  },
};
